import React from "react"
import { EstrategiasFornecedorInicial, EstrategiasFornecedorModel } from "../models/estrategiasFornecedorModel"
import { EstrategiasFornecedorAction } from "./estrategiasFornecedorActions"

interface EstrategiasFornecedorContextType {
    dados: EstrategiasFornecedorModel
    dispatch: React.Dispatch<EstrategiasFornecedorAction>
    erroCarregamento: string | null
}

export const EstrategiasFornecedorContext = React.createContext<EstrategiasFornecedorContextType>({
    dados: EstrategiasFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
